type iCB = (file: string) => void

export class FileDispatcher {
    streams = 4;
    activeStreams = 0;
    queue: Array<{
        src: string,
        cb?: (file: string) => void | null,
    }> = [];
    filesData: { [key: string]: {
            dataURL: string,
            onload: Array<iCB>,
        }} = {};
    queueInterval: ReturnType<typeof setInterval> | null = null;
    enable = false;

    constructor() {
        this.queueInterval = setInterval(() => {
            for(let i = 0; i<=this.streams-this.activeStreams; i++) {
                this.checkQueue();
            }
        }, 100);
    }

    loadByWorker = (src: string): Promise<Blob> => {
        return new Promise((resolve, reject) => {
            const worker = new Worker(new URL('/src/workers/loadWorker.ts', import.meta.url));
            worker.addEventListener('message', (e) => {
                if (e.data) {
                    resolve(e.data);
                    worker.terminate();
                }
            }, false);
            worker.postMessage(window.location.origin + '/' + src);
        });
    };

    getAsync(src: string) {
        return new Promise((resolve, reject) => {
            this.get(src, (resolve));
        });
    }

    getExist(src: string) {
        if (this.filesData[src] !== undefined && this.filesData[src].dataURL.length > 0)  {
            return this.filesData[src].dataURL;
        }
        return null;
    }

    addCb(src: string, cb?: iCB) {
        if (!(cb)) return;
        if (!this.filesData[src].onload) {
            this.filesData[src].onload = [ cb ];
        } else {
            this.filesData[src].onload.push(cb);
        }
    }

    get(src: string, cb?: iCB) {
        // Файл загружен
        if (this.filesData[src] !== undefined && this.filesData[src].dataURL.length > 0) {
            if (cb) {
                cb(this.filesData[src].dataURL);
            }
        // Файл в процессе загрузки
        } else if (this.filesData[src] !== undefined) {
            this.addCb(src, cb);
        // Загрузка еще не начиналась, но уже в очреди
        } else if (this.queue.some((item)=>item.src === src)) {
            const itemIndex = this.queue.findIndex((item)=>item.src === src);
            if (itemIndex === -1) return;
            // const item = this.queue[itemIndex];
            // Перемещаем в начало очереди
            this.queue.unshift(this.queue.splice(itemIndex, 1)[0]);
            // TODO обновляем коллбэк, но вдруг понадобиться предыдущий
            if (cb) {
                this.queue[0].cb = cb;
            }
        // Загрузка еще не начиналась и нет в очреди
        } else {
            this.load(src, cb);
        }
    }

    checkQueue() {
        if (!this.enable) return;
        //Скипаем если достигли лимита стримов
        if (this.activeStreams >= this.streams) return;
        const item = this.queue.shift();
        if (!item) return;

        const emptyFunc = ()=>null;
        this.filesData[item.src] = {
            dataURL: '',
            onload: item.cb ? [ item.cb ] : [],
        };

        this.loadByWorker(item.src)
            .then((dataURL)=>{
                this.filesData[item.src].dataURL = URL.createObjectURL(dataURL);
                this.filesData[item.src].onload.forEach((cb)=>cb(this.filesData[item.src].dataURL));
                this.filesData[item.src].onload = [];
            });
    }

    load(src: string, cb?: (file: string) => void | null) {
        // Скипаем если файл загружен или загружается
        if (this.filesData[src] !== undefined) return;

        this.queue.push({ src, cb });
        this.checkQueue();
    }

    preloadAssets(asset: Array<string>) {
        asset.forEach((item) => {
            this.get(item);
        });
    }

}

